export default __webpack_public_path__ + "static/media/Group 439.e50b154a.png";